import * as constants from './constants';
import { asyncActionsCreator } from '../../global/redux';

export const getOperators = asyncActionsCreator(constants.GET_OPERATORS);
